import { Box, Heading as ChakraHeading, Flex } from "@chakra-ui/react"

export default function Heading({ title, children }){
    return(
    <Flex justifyContent="space-between" alignItems="center">
        <ChakraHeading size="lg" children={title} />
        <Box>{children}</Box>
    </Flex>
    )
}